module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box--highlight"
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-narrow is-flex"
  }, [_c('div', {
    staticClass: "tier is-flex"
  }, [_c('div', {
    staticClass: "tier__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.tierIcon,
      "alt": ((_vm.summoner.rank) + " icon")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-flex"
  }, [_c('div', {
    staticClass: "summoner is-flex"
  }, [_c('div', {
    staticClass: "summoner__name"
  }, [_vm._v(_vm._s(_vm.summoner.name))]), _vm._v(" "), (_vm.summoner.rank) ? _c('div', {
    staticClass: "summoner__rank"
  }, [_vm._v(_vm._s(_vm.summoner.rank) + ", " + _vm._s(_vm.summoner.league_points) + " LP")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow is-flex"
  }, [_c('div', {
    staticClass: "summoner-score is-flex"
  }, [_c('div', {
    staticClass: "summoner-score__value"
  }, [_vm._v(_vm._s(_vm.summoner.score))]), _vm._v(" "), _c('div', {
    staticClass: "summoner-score__subtitle"
  }, [_vm._v("Leaguepoints Score")]), _vm._v(" "), _c('QueueSwitcher')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5318dc99","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SummonerBanner.vue
// module id = 402
// module chunks = 1